export const environment = {
    apiUrl: 'https://rinico.dankospark.co.za/api/',
};
